import { GeneralContentSchemaType } from "~/lib/schemas/generalContentSchema.schema";
import { ProductComponent } from "./product-component";
import { ContentDetailDrawer } from "./content-detail-drawer";
import { isNeedToShowDetailProduct } from "~/lib/utils";

interface HorizontalProductsComponentProps {
  contents: GeneralContentSchemaType[];
}
export function HorizontalProductsComponent({ contents }: HorizontalProductsComponentProps) {

  return (
    <div className="overflow-x-auto">
      <div className="flex space-x-2 min-w-max">
        {contents.map((item, index) => {
          if (isNeedToShowDetailProduct(item.action_titles, item.action_urls) && item.content_type !== 'link') {
            return (
              <ContentDetailDrawer key={`${item.id}`}  content={{
                ...item,
                created_at: item.created_at ?? '',
                updated_at: item.updated_at ?? '',
                currency: item.currency ?? '',
                id: item.id ?? '',
                title: item.title ?? '',
                description: item.description ?? '',
                price: item.price ?? null,
                thumbnail_url: item.thumbnail_url ?? null,
                image_urls: item.image_urls ?? null,
              }}>
                <ProductComponent
                  key={`${item.id}-${index}`}
                  data={{
                    ...item,
                    id: item.id ?? '',
                    created_at: item.created_at ?? '',
                    updated_at: item.updated_at ?? '',
                    price: item.price ?? null,
                    thumbnail_url: item.thumbnail_url ?? null,
                    image_urls: item.image_urls ?? null,
                  }}
                  source='carousel'
                  onClick={undefined} // Pass undefined to use the DrawerTrigger's onClick
                />
              </ContentDetailDrawer>
            )
          } else {
            return (
              <ProductComponent
                key={`${item.id}-${index}`}
                data={{
                  ...item,
                  id: item.id ?? '',
                  created_at: item.created_at ?? '',
                  updated_at: item.updated_at ?? '',
                  price: item.price ?? null,
                  thumbnail_url: item.thumbnail_url ?? null,
                  image_urls: item.image_urls ?? null,
                }}
                source='carousel'
              />
            )
          }
        })}
      </div>
    </div>
  );
}